<template>
  <div class="how-it-works-info__content">
   <span class="how-it-works-info__mobile-title">Como funciona?</span>
    <ul class="how-it-works-info__list">
      <li class="how-it-works-info__list-item">
        <div class="how-it-works-info__list-item-header">
          <VLazyImage
            alt="Passo Um"
            class="how-it-works-info__image"
            :src="steps.firstStep"
            width="60"
            height="60"
          />

          <h3 class="how-it-works-info__title">Encontre sua bolsa de estudos</h3>
        </div>
        <p class="how-it-works-info__paragraph">
          Faça uma busca para encontrar sua faculdade ou curso, pelo preço que você pode pagar.
        </p>
      </li>

      <li class="how-it-works-info__list-item">
        <div class="how-it-works-info__list-item-header">
          <VLazyImage
            alt="Passo Dois"
            class="how-it-works-info__image"
            :src="steps.secondStep"
            width="60"
            height="60"
          />

          <h3 class="how-it-works-info__title">Faça sua pré-matrícula online para garantir sua bolsa</h3>
        </div>
        <p class="how-it-works-info__paragraph">
          Encontrou a melhor opção? Inscreva-se e garanta sua bolsa na hora através do pagamento da pré-matrícula.
        </p>
      </li>

      <li class="how-it-works-info__list-item">
        <div class="how-it-works-info__list-item-header">
          <VLazyImage
            alt="Passo Três"
            class="how-it-works-info__image"
            :src="steps.thirdStep"
            width="60"
            height="60"
          />

          <h3 class="how-it-works-info__title">Economize na mensalidade</h3>
        </div>
        <p class="how-it-works-info__paragraph">
          Faça o processo seletivo da faculdade, apresente o Comprovante de pré-matrícula e matricule-se com a bolsa até o fim do curso.
        </p>
      </li>

      <li class="how-it-works-info__list-item text-center">
        <a class="link link--l link--gold" href="/perguntas-frequentes">Tire todas suas dúvidas na central de ajuda</a>
      </li>
    </ul>
  </div>
</template>

<style lang="sass" scoped>
  // variables must be imported
  @import '~/assets/stylesheets/utils/module.sass'
  @import '~/assets/stylesheets/components/module.sass'

  .how-it-works-info__content
    color: gray
    margin: -$space-s -12px
    width: 446px

  .how-it-works-info__mobile-title
    display: none

  .how-it-works-info__list
    list-style: none
    margin: 0
    padding: 0

  .how-it-works-info__list-item
    border-bottom: 1px solid $lightest-gray
    padding: $space-m

    &:last-child
      background: $lightest-beige
      border-bottom: 0
      border-radius: 0 0 $border-radius $border-radius

  .how-it-works-info__list-item-header
    align-items: center
    display: flex

  .how-it-works-info__image
    +square(60px)

  .how-it-works-info__title
    color: $dark-gray
    font-size: rem(16)
    font-weight: 700
    margin: 0
    padding-left: $space-m

  .how-it-works-info__paragraph
    font-size: rem(16)
    line-height: rem(22)
    margin-bottom: 10px
    padding: $space-s

</style>

<style lang="sass">
  // Sorry for this
  .popover
    max-width: unset !important

</style>

<script>
  import VLazyImage from "v-lazy-image";

  import firstStep from '~/assets/images/how-it-works-step-1.png';
  import secondStep from '~/assets/images/how-it-works-step-2.png';
  import thirdStep from '~/assets/images/how-it-works-step-3.png';

  export default {
    props: ['target-id'],
    components: {
      VLazyImage,
    },
    data() {
      return {
        steps: {
          firstStep,
          secondStep,
          thirdStep,
        },
      };
    },
  };
</script>
